import { CategoryFilterItemProps } from 'component/page/search/SortAndFilter/CategoryFilter/CategoryFilter.types';
import React from 'react';
import { Box, Divider, RadioButton, Typography } from '@drone-js/core';

const CategoryFilterItem: React.FC<CategoryFilterItemProps> = (props) => {
    const radioRef = React.useRef<HTMLInputElement>(null);
    const { item, onCategoriesChange, index } = props;
    if (!item) {
        return null;
    }

    const handleParentClick = () => {
        if (radioRef.current) {
            radioRef.current.click();
        }
    };

    return (
        <>
            {/* eslint-disable-next-line @agoda/agoda-a11y/no-incorrect-props, @agoda/agoda-a11y/no-incorrect-drone-box-usage -- @agoda/agoda-a11y/no-incorrect-props[e1ebdc37-6c62-478d-a5f0-cfd9aa4cfc02], @agoda/agoda-a11y/no-incorrect-drone-box-usage[d56dc2e5-33c9-46ca-9913-850bd13015fa] */}
            <Box
                data-element-name="activities-categories-filter"
                data-testid="activities-categories-filter"
                data-element-index={index + 1}
                flexDirection="row"
                display="flex"
                width="100%"
                justifyContent="space-between"
                alignItems="center"
                onClick={handleParentClick}
                cursor="pointer"
            >
                <RadioButton
                    key={item.label}
                    selection={item.selected ? 'selected' : 'unselected'}
                    role="radio"
                    tabIndex={item.selected ? 0 : -1}
                    label={item.label}
                    onChange={onCategoriesChange}
                    my="16"
                    value={item.values[0] || ''}
                    ref={radioRef}
                >
                    <Box flexDirection="column">
                        <Typography variant="body-default" textColor="base.default">
                            {item.label}
                        </Typography>
                        {item.subLabel && (
                            <Typography variant="body-s" textColor="base.subtle" pt="4">
                                {item.subLabel}
                            </Typography>
                        )}
                    </Box>
                </RadioButton>
                <Typography variant="body-default" textColor="base.default">
                    ({item.count})
                </Typography>
            </Box>
            <Divider />
        </>
    );
};
CategoryFilterItem.displayName = 'CategoryFilterItem';

export default CategoryFilterItem;
